<section class="page-container">

    <div class="container">
        <div class="discountDiv">
            <div class="redeemInstruction">
                <p>
                    <i class="fa-solid fa-triangle-exclamation"></i> This is a single use discount. It will not be available again after redemption.
                    <br />
                    Do not click Redeem Now until you are at checkout and preparing to pay.
                </p>
            </div>
            <div class="couponCard card h-100">
                <img *ngIf="discount.logoUrl != ''" src="{{discount.logoUrl}}" class="couponLogo">
                <div *ngIf="discount.logoUrl == ''" class="noLogo">{{discount.companyName}}</div>
                <h3>{{discount.value}}</h3>
                <p>{{discount.validThroughString}}</p>
                <div class="couponRow">
                    <a *ngIf="!showClaimSuccess" class="btn couponBtn" id="couponBtn" (click)="redeem()">Redeem Now</a>
                    <div *ngIf="showClaimSuccess" class="yayDiv" style="display: block;" id="yayDiv"><i class="fa-regular fa-circle-check"></i> Successfully Redeemed!</div>
                </div>
                <div class="circle1"></div>
                <div class="circle2"></div>
            </div>
        </div>
    </div>
</section>